import { connectAndUpdateStateForSingleNetwork } from '../common/and.js';

export const recommended = [connectAndUpdateStateForSingleNetwork()];
